// Chakra imports
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import XmlDownload from "./XmlDownload";
import React from "react";

const ShowResults = ({ title, xml1, myerror }) => {
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card my={{ lg: "24px" }} me={{ lg: "24px" }}>
      <Flex direction='column'>
        <CardHeader py='2px'>
          <Text color={textColor} fontSize='lg' fontWeight='bold'>
            {title}
          </Text>
        </CardHeader>
        <CardBody>
          <Flex direction='column' w='100%'>
            {xml1 && <XmlDownload title="Αποτελέσματα αναζήτησης" json={xml1}/>}
          </Flex>
        </CardBody>
      </Flex>
    </Card>
  );
};

export default ShowResults;
